import { X, FileText } from "lucide-react";
import FileUpload from "./FileUpload";

export default function MultiFileUpload({ label, value = [], onChange, onBusy, accept = "*", testid }) {
  const list = Array.isArray(value) ? value : [];
  return (
    <div>
      {label && <label className="block text-xs uppercase tracking-[0.12em] text-[#9C8F94] mb-2">{label}</label>}
      {list.length > 0 && (
        <div className="space-y-2 mb-3">
          {list.map((p, i) => (
            <div key={i} className="flex items-center gap-2 bg-[#FBF5F1] border border-[rgba(61,50,56,0.1)] rounded-lg px-3 py-2" data-testid={`${testid}-item-${i}`}>
              <FileText className="w-4 h-4 text-[#C6899E] shrink-0" />
              <span className="text-xs text-[#8C7E83] truncate flex-1">{p.split("/").pop()}</span>
              <button type="button" onClick={() => onChange(list.filter((_, idx) => idx !== i))} className="text-[#9C8F94] hover:text-red-400">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
      <FileUpload accept={accept} value={null} onChange={(p) => onChange([...list, p])} onBusy={onBusy} testid={testid} />
    </div>
  );
}
